export default __webpack_public_path__ + "images/models/8f540525c16c59ba054ba099a8f03cca.usdz";